export const goToTodayStringLowerCaseText = "rDURe";
export default {goToTodayStringLowerCaseText};